
import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const putUpdatePaymentByUserId = (params) => {
    return axios.put(`${backendHost}/api/admin/payment/update/by-user`, params);
};